"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PsuedoDiv = exports.OTPContainer = exports.Input = exports.SampleStyle = void 0;
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const responsive_1 = require("./responsive");
exports.SampleStyle = building_blocks_ui_common_1.styled.div `
  width: 360px;
`;
exports.Input = building_blocks_ui_common_1.styled.input `
  outline: none;
  -webkit-appearance: none;
  width: 60px;
  height: 60px;
  font-size: 16px;
  border-radius: 8px;
  margin-right: 20px;
  border: 1px solid ${(props) => (props.isFocus ? '#696969' : '#E0E0E8')};
  text-align: center;
  @media ${responsive_1.device.mobileS} {
    margin-right: 15px;
  }
  &::placeholder {
    color: #f0f0f6;
    font-size: 20px;
  }
`;
exports.OTPContainer = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) ``;
exports.PsuedoDiv = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  height: 60px;
  width: 30px;
  cursor: text;
  @media ${responsive_1.device.tablet} {
    width: 40px;
  }
`;
//# sourceMappingURL=otpInput.styles.js.map